import { useQuery } from "react-query";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { IeLynxObject } from "../../common/models/eLynxObject";
import CommDataService from "../../services/comm-data-service/CommDataService";
import { IAcmDeviceProtocolObjectUsage } from "../../services/comm-data-service/Models";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseObjectCommDataParameters = {
    groupID: number;
    contextObject: IeLynxObject;
} & BaseUseQueryParameters<IAcmDeviceProtocolObjectUsage>;

export function useObjectCommData({
    groupID,
    contextObject,
    enabled,
    onError,
    onSuccess,
    refreshSeconds
}: UseObjectCommDataParameters) {
    return useQuery<IAcmDeviceProtocolObjectUsage, RestError>(
        keys.commData(groupID, contextObject),
        ({ signal }) => {
            return CommDataService.getObjectCommData(groupID, contextObject.id, contextObject.objectType, signal);
        },
        {
            enabled: !(enabled === false) && (contextObject.objectType === eLynxObjectTypeEnum.Device || contextObject.objectType === eLynxObjectTypeEnum.Well),
            onError: onError,
            onSuccess: onSuccess,
            refetchInterval: refreshSeconds ? refreshSeconds  * 1000 : false
        }
    );
}
